(function () {

  if (window.__cartIconToPage) return;

  window.__cartIconToPage = true;

  document.addEventListener(

    'click',

    function (e) {

      if (!e.isTrusted) return;

      var icon = e.target.closest && e.target.closest('#cart-icon-bubble');

      if (!icon) return;

      e.stopPropagation();

      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      if (e.defaultPrevented) {

        window.location.href = icon.getAttribute('href') || '/cart';

      }

    },

    true

  );

})();

(function () {

  if (window.__proctersBundleCartV4) return;

  window.__proctersBundleCartV4 = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var renderLock = false;

  function escapeHtml(value) {

    return String(value == null ? '' : value)

      .replace(/&/g, '&amp;')

      .replace(/</g, '&lt;')

      .replace(/>/g, '&gt;')

      .replace(/"/g, '&quot;')

      .replace(/'/g, '&#039;');

  }

  function money(cents) {

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';

    var locale = document.documentElement.lang || 'en-GB';

    try {

      return new Intl.NumberFormat(locale, {

        style: 'currency',

        currency: currency,

      }).format((Number(cents) || 0) / 100);

    } catch (error) {

      return '£' + ((Number(cents) || 0) / 100).toFixed(2);

    }

  }

  function bundleId() {

    if (window.crypto && typeof window.crypto.randomUUID === 'function') {

      return window.crypto.randomUUID();

    }

    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);

  }

  function requestJson(url, options) {

    return fetch(url, options).then(function (response) {

      return response.json().then(function (payload) {

        if (!response.ok || payload.status || payload.errors) {

          var message = payload.description || payload.message || payload.errors || 'Cart update failed.';

          throw new Error(typeof message === 'string' ? message : 'Cart update failed.');

        }

        return payload;

      });

    });

  }

  function mainCartSectionId() {

    var mainCart = document.getElementById('main-cart');

    return mainCart ? mainCart.getAttribute('data-id') || '' : '';

  }

  function cartSectionsForPage() {

    var sections = ['cart-drawer', 'cart-icon-bubble'];

    var cartSectionId = mainCartSectionId();

    /* On /cart, request the actual section instance that is already on the

       page. Requesting the bare section filename can render a static/default

       instance and is what caused the cart to fall back to the old-looking

       layout after a bundle removal. */

    if (cartSectionId) sections.push(cartSectionId);

    return sections;

  }

  function setDealError(deal, message) {

    if (!deal) return;

    var existing = deal.querySelector('[data-ph-bundle-error]');

    if (!message) {

      if (existing) existing.remove();

      return;

    }

    if (!existing) {

      existing = document.createElement('p');

      existing.setAttribute('data-ph-bundle-error', '');

      existing.className = 'ph-bundle-deal__error';

      var summary = deal.querySelector('.ph-bundle-deal__summary');

      if (summary) summary.appendChild(existing);

      else deal.prepend(existing);

    }

    existing.textContent = message;

  }

  function selectedDealItems(deal) {

    if (!deal) return [];

    return Array.prototype.slice.call(deal.querySelectorAll('[data-ph-bundle-product]')).filter(function (item) {

      var checkbox = item.querySelector('[data-ph-bundle-checkbox]');

      return checkbox && checkbox.checked && !checkbox.disabled;

    });

  }

  function itemTitle(item) {

    var title = item.querySelector('.card__heading a, .card__heading, [data-product-card-title-id]');

    return title ? title.textContent.trim() : 'Bundle item';

  }

  function normaliseDisplayOnlyDiscounts() {

    /*

      Bundle discounts are now allowed to retain the percentage supplied by

      the bundle_deal metaobject. The Shopify Discount Function will enforce

      the real discount in cart and checkout, so this function intentionally

      does nothing.

    */

  }

  function ensureDrawerReady(drawer) {

    if (!drawer) return false;

    try {

      if (typeof window.loadTemplateContent === 'function') window.loadTemplateContent(drawer);

      if (typeof drawer.init === 'function') drawer.init();

    } catch (error) {

      console.warn('Unable to initialise cart drawer.', error);

    }

    return !!drawer.querySelector('.drawer__inner');

  }

  function renderCartIcon(parsedState) {

    if (!parsedState || !parsedState.sections || !parsedState.sections['cart-icon-bubble']) return;

    var icon = document.getElementById('cart-icon-bubble');

    if (!icon) return;

    var doc = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');

    var source = doc.querySelector('.shopify-section');

    if (source) icon.innerHTML = source.innerHTML;

  }

  function renderMainCart(parsedState) {

    if (!parsedState || !parsedState.sections) return;

    var current = document.getElementById('main-cart');

    if (!current) return;

    var sectionId = mainCartSectionId();

    var sectionHtml = (sectionId && parsedState.sections[sectionId]) || parsedState.sections['main-cart'];

    if (!sectionHtml) return;

    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');

    var source = doc.getElementById('main-cart');

    if (!source) return;

    /* Keep the live #main-cart shell in place. It carries the current section

       instance, styling context and runtime state. Only swap the two pieces

       that genuinely need fresh Liquid after a cart mutation. */

    var liveItems = current.querySelector('#main-cart-items-wrapper');

    var freshItems = source.querySelector('#main-cart-items-wrapper');

    if (liveItems && freshItems) liveItems.replaceWith(freshItems);

    var liveSummary = current.querySelector('#cart-summary');

    var freshSummary = source.querySelector('#cart-summary');

    if (liveSummary && freshSummary) {

      /* Match the theme's normal cart behaviour: keep already-loaded related

         product markup so a quantity/remove action does not flash it empty. */

      var liveRecommendations = liveSummary.querySelector('.cart__recommendations');

      var freshRecommendations = freshSummary.querySelector('.cart__recommendations');

      if (liveRecommendations && freshRecommendations && liveRecommendations.innerHTML.trim()) {

        freshRecommendations.innerHTML = liveRecommendations.innerHTML;

      }

      liveSummary.replaceWith(freshSummary);

    }

    current.classList.toggle('is-empty', source.classList.contains('is-empty'));

    if (typeof window.loadTemplateContent === 'function') window.loadTemplateContent(current);

    if (typeof window.renderSelects === 'function') window.renderSelects();

    if (typeof window.loadDesktopOnlyTemplates === 'function') window.loadDesktopOnlyTemplates();

  }

  function renderDrawer(parsedState) {

    var drawer = document.querySelector('cart-drawer');

    if (!drawer) {

      renderCartIcon(parsedState);

      return null;

    }

    if (!ensureDrawerReady(drawer)) {

      renderCartIcon(parsedState);

      return null;

    }

    var rendered = false;

    if (

      parsedState &&

      parsedState.sections &&

      parsedState.sections['cart-drawer'] &&

      typeof drawer.renderContents === 'function'

    ) {

      rendered = drawer.renderContents(parsedState, true) !== false;

    }

    if (!rendered && typeof drawer.reload === 'function') {

      drawer.reload().then(function () {

        renderCartBundles();

      });

    }

    return drawer;

  }

  function applyCartState(parsedState, options) {

    options = options || {};

    renderMainCart(parsedState);

    renderCartIcon(parsedState);

    var drawer = renderDrawer(parsedState);

    /* Rebuild from the freshly rendered Liquid rows. No cart-state cache,

       line-number guessing or extra /cart.js request is involved. */

    renderCartBundles();

    if (options.openDrawer && drawer && typeof drawer.open === 'function') {

      drawer.open();

    }

    return parsedState;

  }

  function bundleSignature(deal, selectedVariantIds) {

    if (!deal || selectedVariantIds.length !== 2) return '';

    var variants = selectedVariantIds

      .map(function (id) {

        return parseInt(id, 10);

      })

      .sort(function (a, b) {

        return a - b;

      });

    if (!Number.isFinite(variants[0]) || !Number.isFinite(variants[1])) return '';

    /* Keep the signature tied to the exact deal configuration the customer

       clicked. Crucially, it records the ORIGINAL selected variants and is

       stored as a private line property, so VAT reconciliation can swap the

       live Standard/VAT-relief variant IDs without changing bundle identity. */

    var discount = String(deal.getAttribute('data-discount-percent') || '0').trim();

    return 'v1:' + variants.join(':') + ':d' + discount;

  }

  function matchingBundleInCart(cart, selectedVariantIds, signature) {

    if (!cart || !Array.isArray(cart.items) || selectedVariantIds.length !== 2) return null;

    var wanted = selectedVariantIds

      .map(function (id) {

        return parseInt(id, 10);

      })

      .sort(function (a, b) {

        return a - b;

      });

    if (!Number.isFinite(wanted[0]) || !Number.isFinite(wanted[1])) return null;

    var groups = Object.create(null);

    cart.items.forEach(function (item) {

      var properties = item && item.properties ? item.properties : {};

      var id = properties._procters_bundle_id || '';

      var role = properties._procters_bundle_role || '';

      var key = item && item.key ? String(item.key) : '';

      var variantId = parseInt(item && (item.variant_id || item.id), 10);

      var quantity = Math.max(0, parseInt(item && item.quantity, 10) || 0);

      var storedSignature = properties._procters_bundle_signature || '';

      if (!id || !key || !Number.isFinite(variantId)) return;

      if (role !== 'primary' && role !== 'companion') return;

      if (!groups[id]) {

        groups[id] = {

          id: id,

          primary: null,

          companion: null,

        };

      }

      if (!groups[id][role]) {

        groups[id][role] = {

          key: key,

          variantId: variantId,

          quantity: quantity,

          signature: storedSignature,

        };

      }

    });

    var ids = Object.keys(groups);

    for (var i = 0; i < ids.length; i += 1) {

      var group = groups[ids[i]];

      if (!group.primary || !group.companion) continue;

      if (group.primary.quantity <= 0 || group.companion.quantity <= 0) continue;

      /* Do not require the two source lines to be perfectly synchronised here.

         If a historic cart has drifted, Buy together can still add exactly

         one of each component without rewriting or reducing either line. */

      var primarySignature = group.primary.signature || '';

      var companionSignature = group.companion.signature || '';

      var hasStoredSignature = !!(primarySignature || companionSignature);

      if (

        signature &&

        primarySignature &&

        companionSignature &&

        primarySignature === companionSignature &&

        primarySignature === signature

      ) {

        return group;

      }

      /* Legacy bundles created before signatures existed still use the old

         exact-variant fallback. Once a signed bundle has been created, never

         ignore its signature and accidentally merge a different deal. */

      if (hasStoredSignature) continue;

      var pair = [group.primary.variantId, group.companion.variantId].sort(function (a, b) {

        return a - b;

      });

      if (pair[0] === wanted[0] && pair[1] === wanted[1]) {

        return group;

      }

    }

    return null;

  }

  function matchingBundleInDom(selectedVariantIds, signature) {

    if (selectedVariantIds.length !== 2) {

      return { inspected: false, match: null };

    }

    var wanted = selectedVariantIds

      .map(function (id) {

        return parseInt(id, 10);

      })

      .sort(function (a, b) {

        return a - b;

      });

    if (!Number.isFinite(wanted[0]) || !Number.isFinite(wanted[1])) {

      return { inspected: false, match: null };

    }

    var roots = [];

    var mainCart = document.getElementById('main-cart');

    if (mainCart) {

      roots.push(mainCart);

    }

    /*

      Make sure the deferred cart drawer exists in the live DOM before using it

      as our local cart-state source. This is local DOM work only: no cart fetch.

    */

    var drawer = document.querySelector('cart-drawer');

    if (drawer && ensureDrawerReady(drawer)) {

      var drawerRoot = document.getElementById('CartDrawer');

      if (drawerRoot && roots.indexOf(drawerRoot) === -1) {

        roots.push(drawerRoot);

      }

    }

    /*

      If neither cart renderer exists for some unexpected reason, report that

      we could not inspect the cart. addSelectedDeal() will then use the old

      /cart.js lookup as a safety fallback.

    */

    if (!roots.length) {

      return { inspected: false, match: null };

    }

    for (var rootIndex = 0; rootIndex < roots.length; rootIndex += 1) {

      var root = roots[rootIndex];

      var groups = Object.create(null);

      Array.prototype.forEach.call(

        root.querySelectorAll('.cart-item[data-ph-bundle-id]'),

        function (row) {

          var id = row.getAttribute('data-ph-bundle-id') || '';

          var role = row.getAttribute('data-ph-bundle-role') || '';

          var key = row.getAttribute('data-cart-item-key') || '';

          var storedSignature = row.getAttribute('data-ph-bundle-signature') || '';

          var variantId = parseInt(

            row.getAttribute('data-ph-line-variant-id'),

            10

          );

          var quantity = Math.max(

            0,

            parseInt(row.getAttribute('data-ph-line-quantity'), 10) || 0

          );

          if (!id || !key || !Number.isFinite(variantId)) {

            return;

          }

          if (role !== 'primary' && role !== 'companion') {

            return;

          }

          if (!groups[id]) {

            groups[id] = {

              id: id,

              primary: null,

              companion: null,

            };

          }

          if (!groups[id][role]) {

            groups[id][role] = {

              key: key,

              variantId: variantId,

              quantity: quantity,

              signature: storedSignature,

            };

          }

        }

      );

      var ids = Object.keys(groups);

      for (var i = 0; i < ids.length; i += 1) {

        var group = groups[ids[i]];

        if (!group.primary || !group.companion) {

          continue;

        }

        if (group.primary.quantity <= 0 || group.companion.quantity <= 0) {

          continue;

        }

        var primarySignature = group.primary.signature || '';

        var companionSignature = group.companion.signature || '';

        var hasStoredSignature = !!(

          primarySignature ||

          companionSignature

        );

        /*

          Modern Procters bundles match by their permanent signature.

          This remains valid even when VAT reconciliation changes the actual

          live variant from Standard to VAT relief.

        */

        if (

          signature &&

          primarySignature &&

          companionSignature &&

          primarySignature === companionSignature &&

          primarySignature === signature

        ) {

          return {

            inspected: true,

            match: group,

          };

        }

        /*

          Signed bundles must never fall through to variant matching. Otherwise

          two different bundle configurations could accidentally merge.

        */

        if (hasStoredSignature) {

          continue;

        }

        /*

          Legacy bundles created before signatures existed retain the previous

          exact-variant fallback.

        */

        var pair = [

          group.primary.variantId,

          group.companion.variantId,

        ].sort(function (a, b) {

          return a - b;

        });

        if (pair[0] === wanted[0] && pair[1] === wanted[1]) {

          return {

            inspected: true,

            match: group,

          };

        }

      }

    }

    return {

      inspected: true,

      match: null,

    };

  }

  function addItemsToCart(items) {

    return requestJson(ROOT + 'cart/add.js', {

      method: 'POST',

      headers: {

        'Content-Type': 'application/json',

        Accept: 'application/json',

      },

      body: JSON.stringify({

        items: items,

        sections: cartSectionsForPage(),

        sections_url: window.location.pathname,

      }),

    });

  }

  function incrementExistingBundle(group) {

    var updates = {};

    /* Add one complete bundle even if an old cart somehow has unequal source

       quantities. Increment each exact line from its own current quantity;

       never reduce or silently normalise either component. */

    updates[group.primary.key] = group.primary.quantity + 1;

    updates[group.companion.key] = group.companion.quantity + 1;

    return requestJson(ROOT + 'cart/update.js', {

      method: 'POST',

      headers: {

        'Content-Type': 'application/json',

        Accept: 'application/json',

      },

      body: JSON.stringify({

        updates: updates,

        sections: cartSectionsForPage(),

        sections_url: window.location.pathname,

      }),

    });

  }

  function addSelectedDeal(deal, button) {

    if (!deal || !button || deal.dataset.phBundleAdding === 'true') return;

    var selected = selectedDealItems(deal);

    if (!selected.length) return;

    setDealError(deal, '');

    deal.dataset.phBundleAdding = 'true';

    var originalText = button.textContent;

    button.disabled = true;

    button.setAttribute('aria-disabled', 'true');

    button.textContent = 'Adding...';

    var selectedVariantIds = selected.map(function (item) {

      return parseInt(item.getAttribute('data-variant-id'), 10);

    });

    if (

      selectedVariantIds.some(function (id) {

        return !Number.isFinite(id);

      })

    ) {

      setDealError(deal, 'One of these products does not have a valid variant to add.');

      deal.dataset.phBundleAdding = 'false';

      button.disabled = false;

      button.setAttribute('aria-disabled', 'false');

      button.textContent = originalText;

      return;

    }

    var label = selected.map(itemTitle).join(' + ');

    var signature = selected.length === 2 ? bundleSignature(deal, selectedVariantIds) : '';

    function makeItems(id) {

      return selected.map(function (item, index) {

        var cartItem = {

          id: selectedVariantIds[index],

          quantity: 1,

        };

        if (id) {

          cartItem.properties = {

            _procters_bundle_id: id,

            _procters_bundle_role: index === 0 ? 'primary' : 'companion',

            _procters_bundle_label: label,

            _procters_bundle_signature: signature,

          };

        }

        return cartItem;

      });

    }

    var mutation;

    if (selected.length === 2) {

      /*

        Fast path: inspect the cart rows already rendered by Liquid.

        Those rows contain the bundle ID, role, line key, source quantity and

        permanent bundle signature, so there is no reason to download /cart.js

        simply to rediscover information already present in the page.

      */

      var domLookup = matchingBundleInDom(

        selectedVariantIds,

        signature

      );

      if (domLookup.inspected) {

        mutation = domLookup.match

          ? incrementExistingBundle(domLookup.match)

          : addItemsToCart(makeItems(bundleId()));

      } else {

        /*

          Safety fallback only.

          If the live cart DOM is unexpectedly unavailable, retain the original

          canonical-cart lookup rather than risk creating a duplicate bundle.

          Under the normal Procters drawer/cart setup this branch should not run.

        */

        mutation = requestJson(ROOT + 'cart.js', {

          method: 'GET',

          headers: {

            Accept: 'application/json',

          },

          cache: 'no-store',

        }).then(function (cart) {

          var existing = matchingBundleInCart(

            cart,

            selectedVariantIds,

            signature

          );

          if (existing) {

            return incrementExistingBundle(existing);

          }

          return addItemsToCart(makeItems(bundleId()));

        });

      }

    } else {

      mutation = addItemsToCart(makeItems(null));

    }

    mutation

      .then(function (payload) {

        return applyCartState(payload, { openDrawer: true });

      })

      .then(function () {

        button.textContent = 'Added';

        window.setTimeout(function () {

          button.textContent = originalText;

        }, 900);

      })

      .catch(function (error) {

        console.error(error);

        setDealError(deal, error.message || 'Unable to add this bundle to the cart.');

        button.textContent = originalText;

      })

      .finally(function () {

        deal.dataset.phBundleAdding = 'false';

        button.disabled = false;

        button.setAttribute('aria-disabled', 'false');

      });

  }

  function rowBundleId(row) {

    return row ? row.getAttribute('data-ph-bundle-id') || '' : '';

  }

  function rowBundleRole(row) {

    return row ? row.getAttribute('data-ph-bundle-role') || '' : '';

  }

  function rowLineKey(row) {

    return row ? row.getAttribute('data-cart-item-key') || '' : '';

  }

  function rowBundleSignature(row) {

    return row ? row.getAttribute('data-ph-bundle-signature') || '' : '';

  }

  function discountPercentFromSignature(signature) {

    var match = String(signature || '').trim().match(/:d(-?\d+(?:\.\d+)?)$/i);

    if (!match) return 0;

    var discount = parseFloat(match[1]);

    if (!Number.isFinite(discount)) return 0;

    return Math.max(0, Math.min(100, discount));

  }

  function rowsForBundle(root, id) {

    var primary = null;

    var companion = null;

    Array.prototype.forEach.call(root.querySelectorAll('.cart-item[data-ph-bundle-id]'), function (row) {

      if (rowBundleId(row) !== id) return;

      var role = rowBundleRole(row);

      if (role === 'primary' && !primary) primary = row;

      if (role === 'companion' && !companion) companion = row;

    });

    return primary && companion ? { primary: primary, companion: companion } : null;

  }

  function bundleIdsInRoot(root) {

    var seen = Object.create(null);

    var ids = [];

    Array.prototype.forEach.call(

      root.querySelectorAll('.cart-item[data-ph-bundle-id][data-ph-bundle-role="primary"]'),

      function (row) {

        var id = rowBundleId(row);

        if (!id || seen[id]) return;

        seen[id] = true;

        ids.push(id);

      }

    );

    return ids;

  }

  function lineQuantity(row) {

    if (!row) return 0;

    var input = row.querySelector('input[name="updates[]"], .quantity__input');

    return input ? Math.max(0, parseInt(input.value, 10) || 0) : 0;

  }

  function lineCurrentTotal(row) {

    return Math.max(0, parseInt(row.getAttribute('data-ph-line-current-total'), 10) || 0);

  }

  function lineWasTotal(row) {

    return Math.max(0, parseInt(row.getAttribute('data-ph-line-was-total'), 10) || 0);

  }

  function groupQuantity(rows) {

    return Math.min(lineQuantity(rows.primary), lineQuantity(rows.companion));

  }

  function groupCurrentTotal(rows) {

    return lineCurrentTotal(rows.primary) + lineCurrentTotal(rows.companion);

  }

  function groupWasTotal(rows) {

    return lineWasTotal(rows.primary) + lineWasTotal(rows.companion);

  }

  function groupBundleDiscountPercent(rows) {

    var primarySignature = rowBundleSignature(rows.primary);

    var companionSignature = rowBundleSignature(rows.companion);

    if (!primarySignature || !companionSignature || primarySignature !== companionSignature) {

      return 0;

    }

    return discountPercentFromSignature(primarySignature);

  }

  function groupHasNativeLineDiscount(rows) {

    return !!(

      rows.primary.querySelector('.discounts__discount') ||

      rows.companion.querySelector('.discounts__discount')

    );

  }

  function bundleDiscountedTotal(total, discountPercent) {

    var safeTotal = Math.max(0, Number(total) || 0);

    var safeDiscount = Math.max(0, Math.min(100, Number(discountPercent) || 0));

    return Math.max(0, Math.round(safeTotal * (100 - safeDiscount) / 100));

  }

  function removeDuplicateIds(root) {

    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('[id]').forEach(function (el) {

      el.removeAttribute('id');

    });

    root.querySelectorAll('[for]').forEach(function (el) {

      el.removeAttribute('for');

    });

    root.querySelectorAll('[aria-describedby], [aria-controls]').forEach(function (el) {

      el.removeAttribute('aria-describedby');

      el.removeAttribute('aria-controls');

    });

  }

  function cloneCartCellAsDiv(source, extraClass) {

    if (!source) return null;

    var clone = document.createElement('div');

    clone.className = (source.className ? source.className + ' ' : '') + extraClass;

    Array.prototype.forEach.call(source.childNodes, function (node) {

      clone.appendChild(node.cloneNode(true));

    });

    clone.hidden = false;

    clone.removeAttribute('aria-hidden');

    clone.removeAttribute('headers');

    removeDuplicateIds(clone);

    return clone;

  }

  function buildIsolatedMainCartMedia(source) {

    if (!source) return null;

 

    /*

      The theme has responsive rules tied to the native cart classes

      (.cart-item__media, .cart-item__image-container and .cart-item__image).

      Those rules are correct for a real cart table row, but our grouped bundle

      component lives inside a custom grid. Reusing the native classes lets the

      mobile cart layout treat the cloned image as though it were still a table

      cell, which can collapse or hide it on screens below 750px.

 

      For the MAIN cart only, build a deliberately isolated image block using

      Procters-only classes. The cart drawer keeps its existing native-class

      clone because that renderer is already working correctly.

    */

    var media = document.createElement('div');

    media.className = 'ph-cart-bundle__component-media ph-cart-bundle__main-component-media';

 

    var sourceImage = source.querySelector('img');

    if (sourceImage) {

      var sourceLink = source.querySelector('a.cart-item__link[href]');
      var sourceRow = source.closest ? source.closest('.cart-item') : null;
      var titleLink = sourceRow ? sourceRow.querySelector('a.cart-item__name[href]') : null;
      var productUrl = (sourceLink && sourceLink.getAttribute('href')) ||
        (titleLink && titleLink.getAttribute('href')) || '';

      var imageContainer = document.createElement('div');

      imageContainer.className = 'ph-cart-bundle__image-container';

 

      var image = document.createElement('img');

      image.className = 'ph-cart-bundle__image';

      image.src = sourceImage.currentSrc || sourceImage.getAttribute('src') || '';

      image.alt = sourceImage.getAttribute('alt') || '';

      image.loading = 'eager';

      image.decoding = 'async';

      image.fetchPriority = 'auto';

      image.hidden = false;

      image.removeAttribute('aria-hidden');

 

      var sourceWidth = parseInt(sourceImage.getAttribute('width'), 10);

      var sourceHeight = parseInt(sourceImage.getAttribute('height'), 10);

      if (sourceWidth > 0) image.width = sourceWidth;

      if (sourceHeight > 0) image.height = sourceHeight;

 

      if (productUrl) {
        var imageLink = document.createElement('a');
        imageLink.className = 'ph-cart-bundle__image-link';
        imageLink.href = productUrl;
        imageLink.setAttribute('aria-label', 'View ' + (
          (titleLink && titleLink.textContent.trim()) || image.alt || 'product'
        ));
        imageLink.appendChild(image);
        imageContainer.appendChild(imageLink);
      } else {
        imageContainer.appendChild(image);
      }

      media.appendChild(imageContainer);

      return media;

    }

 

    /* Preserve the theme's no-photo placeholder without carrying over the

       responsive cart-cell class that caused the mobile conflict. */

    Array.prototype.forEach.call(source.childNodes, function (node) {

      if (node.nodeType === 1 && node.matches && node.matches('a.cart-item__link')) return;

      media.appendChild(node.cloneNode(true));

    });

    removeDuplicateIds(media);

    return media;

  }

 

  function buildComponent(row) {

    var component = document.createElement('div');

    component.className = 'ph-cart-bundle__component';

    var media = row.querySelector('.cart-item__media');

    var details = row.querySelector('.cart-item__details');

    if (media) {

      var isMainCart = !!(row.closest && row.closest('#main-cart'));

      var mediaClone = isMainCart

        ? buildIsolatedMainCartMedia(media)

        : cloneCartCellAsDiv(media, 'ph-cart-bundle__component-media');

 

      if (mediaClone) {

        mediaClone.querySelectorAll('img').forEach(function (image) {

          image.hidden = false;

          image.removeAttribute('aria-hidden');

          /* Bundle rows are already in view when we construct them. Do not let

             a lazy source row that is about to be hidden delay the clone. */

          if (image.getAttribute('src')) {

            image.setAttribute('loading', 'eager');

          }

        });

        component.appendChild(mediaClone);

      }

    }

    if (details) {

      var detailsClone = cloneCartCellAsDiv(details, 'ph-cart-bundle__component-details');

      if (detailsClone) {

        /* Bundle component details are cloned from the native cart row. Keep

           genuine product options, but never expose the internal VAT price-mode

           option. Standard is hidden completely. VAT relief is rewritten to the

           customer-facing status used by ordinary cart items. */

        detailsClone.querySelectorAll('.product-option').forEach(function (option) {

          var dt = option.querySelector('dt');

          var dd = option.querySelector('dd');

          if (!dt || !dd) return;

          var optionName = String(dt.textContent || '')

            .replace(/:\s*$/, '')

            .trim()

            .toLowerCase();

          var optionValue = String(dd.textContent || '').trim().toLowerCase();

          if (optionName !== 'price') return;

          if (optionValue === 'standard') {

            option.remove();

            return;

          }

          if (optionValue === 'vat relief') {

            dt.textContent = 'VAT status:';

            dt.className = 'visually-hidden';

            dd.textContent = 'VAT relief applied';

            option.classList.add('ph-cart-vat-relief-applied');

          }

        });

        detailsClone.querySelectorAll('dl').forEach(function (list) {

          if (!list.querySelector('.product-option') && !list.textContent.trim()) {

            list.remove();

          }

        });

        detailsClone.querySelectorAll('.product-option--price, .cart-item__discounted-prices').forEach(function (el) {

          el.remove();

        });

        component.appendChild(detailsClone);

      }

    }

    return component;

  }

  function nativeMetrics(row) {

    var result = {

      mediaWidth: 80,

      mediaGap: 12,

      totalGap: 12,

    };

    if (!row || !row.getBoundingClientRect) return result;

    var media = row.querySelector('.cart-item__media');

    var visualMedia = row.querySelector('.cart-item__image-container') || media;

    var details = row.querySelector('.cart-item__details');

    var detailsVisual = row.querySelector('.cart-item__name') || details;

    var totals = row.querySelector('.cart-item__totals:not(.small-hide), .cart-item__totals');

    if (visualMedia && detailsVisual) {

      var mediaRect = visualMedia.getBoundingClientRect();

      var detailsRect = detailsVisual.getBoundingClientRect();

      if (mediaRect.width > 0) result.mediaWidth = mediaRect.width;

      /* The main cart becomes a constrained HTML table at 750px. Under table
         pressure the native image container can report a squeezed width, and
         that measured value used to be copied straight into the grouped bundle.
         Keep the custom main-cart bundle image within the design's normal
         80-100px range instead of inheriting a transient table measurement. */
      if (
        row.closest &&
        row.closest('#main-cart') &&
        window.matchMedia &&
        window.matchMedia('(min-width: 750px) and (max-width: 989.98px)').matches
      ) {
        result.mediaWidth = Math.max(80, Math.min(100, result.mediaWidth));
      }

      /* Measure to the actual title, not the outer details cell. The native

         details cell carries its own inset, so measuring the cell edge made

         the cloned bundle title sit too close to the image. */

      var mediaGap = detailsRect.left - mediaRect.right;

      if (mediaGap >= 0 && mediaGap < 100) result.mediaGap = mediaGap;

      if (totals) {

        var totalsRect = totals.getBoundingClientRect();

        var totalGap = totalsRect.left - detailsRect.right;

        if (totalGap >= 0 && totalGap < 160) result.totalGap = totalGap;

      }

    }

    return result;

  }

  function bundleSavingsCents(rows) {
    var discountPercent = groupBundleDiscountPercent(rows);
    if (discountPercent <= 0) return 0;

    var currentTotal = groupCurrentTotal(rows);

    if (groupHasNativeLineDiscount(rows)) {
      if (discountPercent >= 100) {
        var originalPrimary = parseInt(rows.primary.getAttribute('data-ph-line-original-total'), 10) || 0;
        var originalCompanion = parseInt(rows.companion.getAttribute('data-ph-line-original-total'), 10) || 0;
        return Math.max(0, originalPrimary + originalCompanion - currentTotal);
      }

      var beforeBundleDiscount = Math.round(currentTotal * 100 / (100 - discountPercent));
      return Math.max(0, beforeBundleDiscount - currentTotal);
    }

    return Math.max(0, currentTotal - bundleDiscountedTotal(currentTotal, discountPercent));
  }

  function buildProductStack(rows, metrics) {

    var stack = document.createElement('div');

    stack.className = 'ph-cart-bundle__product-stack';

    stack.style.setProperty('--ph-bundle-media-width', metrics.mediaWidth + 'px');

    stack.style.setProperty('--ph-bundle-media-gap', metrics.mediaGap + 'px');

    var eyebrow = document.createElement('span');

    eyebrow.className = 'ph-cart-bundle__eyebrow';

    eyebrow.textContent = 'Bundle';

    stack.appendChild(eyebrow);

    var savingCents = bundleSavingsCents(rows);
    if (savingCents > 0) {
      var savingsBadge = document.createElement('span');
      savingsBadge.className = 'badge ph-cart-bundle__savings-badge';
      savingsBadge.textContent = "You're saving " + money(savingCents);
      stack.appendChild(savingsBadge);
    }

    stack.appendChild(buildComponent(rows.primary));

    var between = document.createElement('div');

    between.className = 'ph-cart-bundle__between';

    between.setAttribute('aria-hidden', 'true');

    var plus = document.createElement('span');

    plus.className = 'ph-cart-bundle__plus';

    plus.textContent = '+';

    between.appendChild(plus);

    stack.appendChild(between);

    stack.appendChild(buildComponent(rows.companion));

    return stack;

  }

  function buildPrice(rows) {

    var nativeCurrentTotal = groupCurrentTotal(rows);

    var historicalWasTotal = groupWasTotal(rows);

    var discountPercent = groupBundleDiscountPercent(rows);

    var nativeDiscountApplied = groupHasNativeLineDiscount(rows);

    var currentTotal = nativeCurrentTotal;

    var wasTotal = historicalWasTotal;

    if (discountPercent > 0) {

      if (nativeDiscountApplied) {

        /*

          Once the Shopify Discount Function is active, final_line_price already

          contains the real server-side reduction. Use it directly so the bundle

          is never discounted twice in the visual cart.

          For the crossed price, reconstruct the active pre-bundle total from

          the signed percentage. This matters for VAT-relief variants because

          groupWasTotal deliberately points back to Standard pricing.

        */

        currentTotal = nativeCurrentTotal;

        if (discountPercent < 100) {

          wasTotal = Math.max(

            currentTotal,

            Math.round(currentTotal * 100 / (100 - discountPercent))

          );

        } else {

          wasTotal = historicalWasTotal;

        }

      } else {

        /*

          Until the server-side Function is activated, Shopify reports the two

          active component totals without the bundle reduction. Calculate the

          DISPLAY price from those active totals. If VAT relief has swapped one

          or both variants, nativeCurrentTotal already contains those relief

          prices, so the bundle percentage is applied after VAT relief.

        */

        wasTotal = nativeCurrentTotal;

        currentTotal = bundleDiscountedTotal(nativeCurrentTotal, discountPercent);

      }

    }

    var wrapper = document.createElement('div');

    wrapper.className = 'cart-item__price-wrapper ph-cart-bundle__price';

    var current = document.createElement('span');

    current.className = 'price price--end whitespace-nowrap';

    current.textContent = money(currentTotal);

    wrapper.appendChild(current);

    if (wasTotal > currentTotal) {

      var hidden = document.createElement('span');

      hidden.className = 'visually-hidden';

      hidden.textContent = 'Regular price';

      wrapper.appendChild(hidden);

      var old = document.createElement('s');

      old.className = 'cart-item__vat-was price-item price-item--regular t6 opacity-70 whitespace-nowrap';

      old.textContent = money(wasTotal);

      wrapper.appendChild(old);

    }

    return wrapper;

  }

  function buildQuantity(rows, id, root) {

    var sourceWrapper = rows.primary.querySelector('.cart-item__quantity-wrapper');

    var shell = sourceWrapper ? sourceWrapper.cloneNode(true) : document.createElement('div');

    if (!sourceWrapper) {

      shell.className = 'cart-item__quantity-wrapper quantity-popover-wrapper';

      var fallbackContainer = document.createElement('div');

      fallbackContainer.className = 'quantity-popover-container';

      fallbackContainer.innerHTML =

        '<div class="quantity quantity--squidge cart-quantity">' +

          '<button class="quantity__button quantity__button-increase tap-target--small no-js-hidden" type="button"></button>' +

          '<input class="quantity__input" type="number" min="0" step="1">' +

          '<button class="quantity__button quantity__button-decrease tap-target--small no-js-hidden" type="button"></button>' +

        '</div>';

      shell.appendChild(fallbackContainer);

    }

    shell.classList.add('ph-cart-bundle__quantity-shell');

    removeDuplicateIds(shell);

    /* Keep the exact native quantity hierarchy and classes, including the

       quantity-popover-container. Only neutralise the quantity-input custom

       element itself so the theme cannot issue a second single-line update. */

    var nativeControl = shell.querySelector('quantity-input');

    var control = null;

    if (nativeControl) {

      control = document.createElement('div');

      control.className = nativeControl.className + ' ph-cart-bundle__quantity-control';

      control.innerHTML = nativeControl.innerHTML;

      nativeControl.replaceWith(control);

    } else {

      control = shell.querySelector('.quantity');

      if (control) control.classList.add('ph-cart-bundle__quantity-control');

    }

    if (!control) return shell;

    var input = control.querySelector('.quantity__input');

    if (input) {

      input.removeAttribute('name');

      input.removeAttribute('data-index');

      input.removeAttribute('data-quantity-variant-id');

      input.removeAttribute('data-cart-quantity');

      input.value = groupQuantity(rows);

      input.setAttribute('value', groupQuantity(rows));

      input.setAttribute('min', '0');

      input.setAttribute('step', '1');

      input.setAttribute('inputmode', 'numeric');

      input.setAttribute('data-ph-bundle-quantity', id);

      input.setAttribute('aria-label', 'Bundle quantity');

      input.id = (root.id === 'CartDrawer' ? 'Drawer-BundleQuantity-' : 'BundleQuantity-') + id.replace(/[^a-zA-Z0-9_-]/g, '-');

      shell.querySelectorAll('label[for]').forEach(function (label) {

        label.setAttribute('for', input.id);

      });

    }

    var increase = control.querySelector('.quantity__button-increase');

    if (increase) {

      increase.type = 'button';

      increase.removeAttribute('name');

      increase.setAttribute('data-ph-bundle-increase', id);

      increase.setAttribute('aria-label', 'Increase bundle quantity');

    }

    var decrease = control.querySelector('.quantity__button-decrease');

    if (decrease) {

      decrease.type = 'button';

      decrease.removeAttribute('name');

      decrease.setAttribute('data-ph-bundle-decrease', id);

      decrease.setAttribute('aria-label', 'Decrease bundle quantity');

    }

    /* cart-remove-button has its own native single-line click behaviour, so

       keep its inner icon/button exactly but replace only the custom-element

       host with an inert span. CSS below aliases the host's native sizing. */

    var nativeRemoveHost = shell.querySelector('cart-remove-button');

    var removeHost = document.createElement('span');

    removeHost.className = 'ph-cart-bundle__remove-host';

    var nativeRemove = nativeRemoveHost && nativeRemoveHost.querySelector('button, a');

    var remove = nativeRemove ? nativeRemove.cloneNode(true) : document.createElement('button');

    removeDuplicateIds(remove);

    if (remove.tagName === 'A') {

      var replacement = document.createElement('button');

      replacement.type = 'button';

      replacement.className = remove.className;

      replacement.innerHTML = remove.innerHTML;

      remove = replacement;

    }

    remove.type = 'button';

    remove.setAttribute('data-ph-remove-bundle', id);

    remove.setAttribute('aria-label', 'Remove bundle');

    remove.classList.add('ph-cart-bundle__remove');

    remove.removeAttribute('href');

    remove.removeAttribute('data-no-instant');

    remove.removeAttribute('data-variant-id');

    remove.removeAttribute('tabindex');

    removeHost.appendChild(remove);

    if (nativeRemoveHost) nativeRemoveHost.replaceWith(removeHost);

    else shell.appendChild(removeHost);

    /* The live theme styles .quantity inside quantity-popover. Preserve that

       ancestor too; this is the small structural detail that makes the bundle

       control truly identical to the control on ordinary cart lines. */

    var popover = document.createElement('quantity-popover');

    popover.className = 'ph-cart-bundle__quantity-popover';

    popover.appendChild(shell);

    return popover;

  }

  function buildMainCartBundleCard(rows, id, metrics, root) {

    var card = document.createElement('div');

    card.className = 'ph-cart-bundle__main-card';

    var products = buildProductStack(rows, metrics);

    products.classList.add('ph-cart-bundle__main-products');

    var quantity = document.createElement('div');

    quantity.className = 'cart-item__quantity ph-cart-bundle__main-quantity';

    quantity.appendChild(buildQuantity(rows, id, root));

    var price = document.createElement('div');

    price.className = 'cart-item__totals right ph-cart-bundle__main-price';

    price.appendChild(buildPrice(rows));

    card.appendChild(products);

    card.appendChild(quantity);

    card.appendChild(price);

    return card;

  }

  function renderGroupInRoot(id, root) {

    var rows = rowsForBundle(root, id);

    if (!rows) return;

    /* This is the safety boundary: the renderer only touches rows that Liquid

       explicitly marked with this exact private bundle id and role. A normal

       line, including the same variant added separately, can never match. */

    if (rowBundleRole(rows.primary) !== 'primary' || rowBundleRole(rows.companion) !== 'companion') return;

    if (rowBundleId(rows.primary) !== id || rowBundleId(rows.companion) !== id) return;

    var primaryKey = rowLineKey(rows.primary);

    var companionKey = rowLineKey(rows.companion);

    if (!primaryKey || !companionKey) return;

    if (rows.primary.getAttribute('data-ph-cart-bundle') === id) return;

    var metrics = nativeMetrics(rows.primary);

    var mediaCell = rows.primary.querySelector('.cart-item__media');

    var detailsCell = rows.primary.querySelector('.cart-item__details');

    var quantityCell = rows.primary.querySelector('.cart-item__quantity');

    var totalCells = rows.primary.querySelectorAll('.cart-item__totals');

    if (!mediaCell || !detailsCell || !quantityCell || !totalCells.length) return;

    rows.primary.hidden = false;

    rows.primary.removeAttribute('aria-hidden');

    rows.primary.removeAttribute('inert');

    rows.primary.setAttribute('data-ph-cart-bundle', id);

    rows.primary.setAttribute('data-ph-bundle-primary-key', primaryKey);

    rows.primary.setAttribute('data-ph-bundle-companion-key', companionKey);

    rows.primary.style.setProperty('--ph-bundle-total-gap', metrics.totalGap + 'px');

    rows.primary.style.setProperty('--ph-bundle-media-width', metrics.mediaWidth + 'px');

    rows.primary.style.setProperty('--ph-bundle-media-gap', metrics.mediaGap + 'px');

    rows.primary.classList.add('ph-cart-bundle-row');

    rows.companion.hidden = true;

    rows.companion.setAttribute('aria-hidden', 'true');

    rows.companion.setAttribute('data-ph-bundle-source-hidden', 'true');

    rows.companion.classList.add('ph-cart-bundle-source-row--hidden');

    if ('inert' in rows.companion) rows.companion.inert = true;

    mediaCell.classList.add('ph-cart-bundle__product-cell');

    if (root.id === 'main-cart') {

      /* The main cart gets one real card spanning the table row. That gives

         the requested border/padding a single reliable box and, importantly,

         leaves the native quantity cells in the form (hidden) rather than

         deleting their updates[] inputs. */

      mediaCell.colSpan = 5;

      mediaCell.replaceChildren(buildMainCartBundleCard(rows, id, metrics, root));

      detailsCell.hidden = true;

      detailsCell.setAttribute('aria-hidden', 'true');

      quantityCell.hidden = true;

      quantityCell.setAttribute('aria-hidden', 'true');

      quantityCell.classList.add('ph-cart-bundle__native-cell--hidden');

      totalCells.forEach(function (cell) {

        cell.hidden = true;

        cell.setAttribute('aria-hidden', 'true');

        cell.classList.add('ph-cart-bundle__native-cell--hidden');

      });

    } else {

      mediaCell.colSpan = 2;

      mediaCell.replaceChildren(buildProductStack(rows, metrics));

      // Anchor the drawer savings badge to the full-width bundle row, not the left product column.
      var drawerSavingsBadge = mediaCell.querySelector('.ph-cart-bundle__savings-badge');
      if (drawerSavingsBadge) rows.primary.appendChild(drawerSavingsBadge);

      detailsCell.hidden = true;

      detailsCell.setAttribute('aria-hidden', 'true');

      quantityCell.classList.add('ph-cart-bundle__quantity-cell');

      quantityCell.replaceChildren(buildQuantity(rows, id, root));

      totalCells.forEach(function (cell) {

        cell.replaceChildren(buildPrice(rows));

      });

    }

  }

  function ensureBundleStyles() {

    if (document.getElementById('ph-cart-bundle-styles-v8')) return;

    var style = document.createElement('style');

    style.id = 'ph-cart-bundle-styles-v8';

    style.textContent = [

      '.ph-bundle-deal__error{grid-column:1/-1;margin:0;font-size:1.3rem;line-height:1.4;color:#b42318}',

      '.ph-cart-bundle-source-row--hidden,.cart-item[data-ph-bundle-source-hidden="true"]{display:none!important}',

      '.ph-cart-bundle-row .cart-item__details[hidden]{display:none!important}',

      '.ph-cart-bundle__product-stack{display:flex;flex-direction:column;min-width:0}',

      '.ph-cart-bundle__eyebrow{display:block;margin:0 0 1rem;color:var(--ph-green,#1f4d40);font-size:1.45rem;font-weight:400!important;font-variation-settings:"wght" 400!important;line-height:1.1;letter-spacing:.07em;text-transform:uppercase}',

      '#main-cart .ph-cart-bundle__eyebrow{font-weight:400!important}',
      '.ph-cart-bundle__savings-badge{position:absolute!important;top:0!important;right:1.5rem!important;left:auto!important;z-index:4!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;margin:0!important;padding:.45rem .85rem!important;transform:translateY(-50%)!important;background:#ffde59!important;background-image:none!important;border:0!important;border-radius:4px!important;box-shadow:none!important;color:#202020!important;font-size:1.15rem!important;font-weight:600!important;line-height:1.1!important;letter-spacing:0!important;text-transform:none!important;white-space:nowrap!important;pointer-events:none!important}',
      '.cart-drawer .ph-cart-bundle-row>.ph-cart-bundle__savings-badge{top:0!important;right:1.5rem!important;left:auto!important;margin-top:0!important;transform:translateY(-50%)!important;border:0!important;box-shadow:none!important}',

      '.ph-cart-bundle__component{display:grid;grid-template-columns:var(--ph-bundle-media-width,8rem) minmax(0,1fr);column-gap:var(--ph-bundle-media-gap,1.2rem);align-items:start;min-width:0}',

      '.ph-cart-bundle__component>.ph-cart-bundle__component-media,.ph-cart-bundle__component>.cart-item__details{display:block!important;width:auto!important;min-width:0!important;max-width:none!important;margin:0!important;padding:0!important}',

      '.ph-cart-bundle__component>.ph-cart-bundle__component-media{display:block!important;width:var(--ph-bundle-media-width,8rem)!important;min-width:var(--ph-bundle-media-width,8rem)!important;max-width:var(--ph-bundle-media-width,8rem)!important;grid-column:1!important;align-self:start!important;visibility:visible!important;opacity:1!important}',

      /* Main-cart bundle media is deliberately self-sized. Peak changes the cart to a real table at 750px, so relying on an auto-height wrapper here makes tablet rendering browser-dependent. Give the isolated main-cart media a definite square box at every viewport. The drawer does not use this class and is untouched. */

      '#main-cart .ph-cart-bundle__main-component-media{display:block!important;width:var(--ph-bundle-media-width,8rem)!important;min-width:var(--ph-bundle-media-width,8rem)!important;max-width:var(--ph-bundle-media-width,8rem)!important;height:var(--ph-bundle-media-width,8rem)!important;min-height:var(--ph-bundle-media-width,8rem)!important;aspect-ratio:1/1!important;grid-column:1!important;align-self:start!important;overflow:visible!important;visibility:visible!important;opacity:1!important}',

      '.ph-cart-bundle__component .cart-item__image-container,.ph-cart-bundle__component .ph-cart-bundle__image-container{display:block!important;position:relative!important;width:100%!important;max-width:none!important;aspect-ratio:1/1!important;overflow:hidden!important;visibility:visible!important;opacity:1!important}',

      '#main-cart .ph-cart-bundle__main-component-media>.ph-cart-bundle__image-container{width:100%!important;height:100%!important;min-height:100%!important;aspect-ratio:1/1!important}',

      '#main-cart .ph-cart-bundle__image-link{display:block!important;width:100%;height:100%;cursor:pointer}',

      '#main-cart .ph-cart-bundle__image-link:focus-visible{outline:2px solid var(--ph-green,#1f4d40);outline-offset:-2px}',

      '.ph-cart-bundle__component .cart-item__image,.ph-cart-bundle__component .ph-cart-bundle__image{display:block!important;width:100%!important;height:100%!important;max-width:none!important;aspect-ratio:1/1!important;object-fit:contain!important;visibility:visible!important;opacity:1!important}',

      '.ph-cart-bundle__component .cart-item__name{margin:0!important}',

      '.ph-cart-bundle__between{display:grid;grid-template-columns:var(--ph-bundle-media-width,8rem) minmax(0,1fr);column-gap:var(--ph-bundle-media-gap,1.2rem);height:3rem;min-height:3rem;align-items:center;overflow:visible}',

      '.ph-cart-bundle__plus{grid-column:1;display:block;justify-self:center;align-self:center;margin:0!important;padding:0!important;color:var(--ph-btn-orange,#f0952e)!important;background:transparent!important;border:0!important;border-radius:0!important;font-family:var(--font-body-family)!important;font-size:3rem!important;font-weight:500!important;line-height:1!important;text-align:center;transform:none!important}',

      '.ph-cart-bundle__price{display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-start;margin:0!important;padding:0!important}',

      '.ph-cart-bundle__price .price{margin:0!important}',

      '.ph-cart-bundle__price .cart-item__vat-was{display:block;margin:.5rem 0 0!important}',

      '.ph-cart-bundle__quantity-popover{display:block;position:relative}',

      '.ph-cart-bundle__quantity-shell{display:flex;align-items:center}',

      '.ph-cart-bundle__quantity-control{flex:0 0 auto}',

      '.ph-cart-bundle__remove-host{display:flex;margin-inline-start:1rem}',

      '.ph-cart-bundle__remove-host .button{min-width:calc(4.5rem / var(--font-body-scale));min-height:4.5rem;padding:0;margin:0 .1rem .1rem;margin-inline-start:0}',

      '.ph-cart-bundle__remove-host .button:before,.ph-cart-bundle__remove-host .button:after{content:none!important}',

      '.ph-cart-bundle__remove-host .icon-remove,.ph-cart-bundle__remove-host svg{width:2rem;height:2rem}',

      '.ph-cart-bundle__remove{display:flex!important;align-items:center!important;justify-content:center!important;color:#000000!important;background:transparent!important;text-decoration:none!important;box-shadow:none!important}',

      '.ph-cart-bundle__remove:hover,.ph-cart-bundle__remove:focus-visible{color:var(--ph-btn-orange,#f0952e)!important;background:transparent!important}',

      '.ph-cart-bundle__remove .icon-remove,.ph-cart-bundle__remove svg{color:inherit!important}',

      '@media screen and (min-width:750px){.ph-cart-bundle__remove-host .button{min-width:3.5rem;min-height:3.5rem}}',

      '@media screen and (min-width:750px) and (max-width:989.98px){.ph-cart-bundle__remove-host{width:4.5rem;height:4.5rem}}',

      '@media screen and (min-width:750px) and (hover:hover) and (pointer:fine){.ph-cart-bundle__remove-host{transform:translateX(calc(-20px * var(--direction-multiplier))) scale(.5);transform-origin:50% 50%;opacity:0;visibility:hidden;transition:opacity .3s,transform .2s var(--cubic-bezier-wipe),visibility .3s}.ph-cart-bundle-row:hover .ph-cart-bundle__remove-host,.tab-active .ph-cart-bundle__remove-host{opacity:1;visibility:visible;transform:translateX(0) scale(1)}}',

      /* Cart drawer bundle card. Light green-grey border and extra vertical separation. */

      '.cart-drawer .ph-cart-bundle-row{display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;grid-template-rows:auto auto!important;grid-template-areas:"product total" "quantity quantity"!important;column-gap:var(--ph-bundle-total-gap,1.2rem)!important;row-gap:1.2rem!important;align-items:start!important;position:relative!important;margin-top:17.5px!important;margin-bottom:17.5px!important;padding:2.5rem 1.5rem 1.5rem!important;border:1px solid #c7d1cc!important;border-radius:8px!important;box-sizing:border-box!important}',

      /* Bundle label uses the approved 15% anchor and shifts slightly on very narrow drawers. */

      '.cart-drawer .ph-cart-bundle-row .ph-cart-bundle__eyebrow{position:absolute!important;top:0!important;left:15%!important;transform:translate(-50%,-50%)!important;z-index:2!important;display:block!important;margin:-22px 0!important;padding:.45rem .8rem!important;background:rgb(var(--color-background))!important;border:1px solid #c7d1cc!important;border-radius:3px!important;color:var(--ph-green,#1f4d40)!important;font-size:1.25rem!important;font-weight:400!important;font-variation-settings:"wght" 400!important;line-height:1.1!important;letter-spacing:.07em!important;text-transform:uppercase!important;white-space:nowrap!important}',

      '@media screen and (max-width:389.98px){.cart-drawer .ph-cart-bundle-row .ph-cart-bundle__eyebrow{left:18%!important}}',

      '.cart-drawer .ph-cart-bundle-row .ph-cart-bundle__product-cell{grid-area:product!important;grid-row:auto!important;grid-column:auto!important;width:auto!important;max-width:none!important;min-width:0!important;padding:0!important;padding-inline-start:0!important}',

      '.cart-drawer .ph-cart-bundle-row .cart-item__totals{grid-area:total!important;align-self:start!important;justify-self:end!important;align-items:flex-start!important;padding:0!important;padding-inline-start:0!important;white-space:nowrap!important}',

      '.cart-drawer .ph-cart-bundle-row .cart-item__quantity{grid-area:quantity!important;grid-column:auto!important;width:100%!important;padding:0!important;padding-inline-start:0!important}',

      '.cart-drawer .ph-cart-bundle__quantity-popover{width:100%}',

      '.cart-drawer .ph-cart-bundle__quantity-shell{display:grid!important;grid-template-columns:4.5rem auto 4.5rem!important;justify-content:start!important;align-items:center!important;column-gap:1rem!important;width:100%!important;padding-inline-start:calc(var(--ph-bundle-media-width,8rem) + var(--ph-bundle-media-gap,1.2rem) - 5.5rem)!important;box-sizing:border-box}',

      '.cart-drawer .ph-cart-bundle__quantity-shell>.quantity-popover-container{grid-column:2!important;padding:0!important}',

      '.cart-drawer .ph-cart-bundle__quantity-shell>.ph-cart-bundle__remove-host{grid-column:3!important;margin-inline-start:0!important}',

      /* Main cart bundle card. One border contains products, quantity and total. */

      '#main-cart .ph-cart-bundle-row .ph-cart-bundle__product-cell{width:auto!important;max-width:none!important;padding-inline:0!important}',

      '#main-cart .ph-cart-bundle-row .ph-cart-bundle__native-cell--hidden{display:none!important}',

      '#main-cart .ph-cart-bundle__main-card{display:grid;grid-template-columns:minmax(0,3fr) minmax(158px,1fr) minmax(90px,1fr);grid-template-areas:"products quantity price";align-items:start;column-gap:0;row-gap:1.2rem;width:100%;padding:10px;border:1px solid #d9d9d6;border-radius:8px;box-sizing:border-box}',

      '#main-cart .ph-cart-bundle__main-products{grid-area:products;min-width:0}',

      '#main-cart .ph-cart-bundle__main-quantity{grid-area:quantity;display:flex!important;align-items:flex-start;justify-content:flex-start;width:auto!important;padding:0 0 0 2rem!important;position:relative;z-index:2;overflow:visible!important}',

      '#main-cart .ph-cart-bundle__main-price{grid-area:price;display:flex!important;align-items:flex-start;justify-content:flex-end;width:auto!important;padding:0 0 0 2rem!important;white-space:nowrap;position:relative;z-index:1}',

      '#main-cart .ph-cart-bundle__main-quantity .ph-cart-bundle__quantity-shell{width:auto}',

      '#main-cart .ph-cart-bundle__main-price .ph-cart-bundle__price{align-items:flex-end}',

      '@media screen and (max-width:749.98px){.cart-drawer .ph-cart-bundle-row .cart-item__totals.medium-hide{display:flex!important}.cart-drawer .ph-cart-bundle-row .cart-item__totals.small-hide{display:none!important}#main-cart .ph-cart-bundle-row{display:table-row!important}#main-cart .ph-cart-bundle-row .ph-cart-bundle__product-cell{grid-column:auto!important;width:auto!important;padding-top:0!important}#main-cart .ph-cart-bundle__main-card{grid-template-columns:minmax(0,1fr) auto;grid-template-areas:"products price" "quantity quantity";column-gap:1.5rem;row-gap:1.2rem}#main-cart .ph-cart-bundle__main-quantity{width:100%!important}#main-cart .ph-cart-bundle__main-quantity .ph-cart-bundle__quantity-popover{width:100%}#main-cart .ph-cart-bundle__main-quantity{padding:0!important}#main-cart .ph-cart-bundle__main-quantity .ph-cart-bundle__quantity-shell{display:grid!important;grid-template-columns:4.5rem auto 4.5rem!important;justify-content:center!important;align-items:center!important;column-gap:1rem!important;width:100%!important}#main-cart .ph-cart-bundle__main-quantity .ph-cart-bundle__quantity-shell>.quantity-popover-container{grid-column:2!important;padding:0!important}#main-cart .ph-cart-bundle__main-quantity .ph-cart-bundle__quantity-shell>.ph-cart-bundle__remove-host{grid-column:3!important;margin-inline-start:0!important}#main-cart .ph-cart-bundle__component{grid-template-columns:var(--ph-bundle-media-width,8rem) minmax(0,1fr)!important}#main-cart .ph-cart-bundle__main-component-media{display:block!important;width:var(--ph-bundle-media-width,8rem)!important;min-width:var(--ph-bundle-media-width,8rem)!important;max-width:var(--ph-bundle-media-width,8rem)!important;height:var(--ph-bundle-media-width,8rem)!important;grid-column:1!important;align-self:start!important;overflow:visible!important;visibility:visible!important;opacity:1!important}#main-cart .ph-cart-bundle__image-container,#main-cart .ph-cart-bundle__image{display:block!important;visibility:visible!important;opacity:1!important}}'

    ].join('');

    document.head.appendChild(style);

  }

  function renderBundlesInRoot(root) {

    if (!root || !root.querySelectorAll) return;

    bundleIdsInRoot(root).forEach(function (id) {

      renderGroupInRoot(id, root);

    });

  }

  function renderCartBundles() {

    if (renderLock) return;

    renderLock = true;

    try {

      ensureBundleStyles();

      renderBundlesInRoot(document.getElementById('main-cart'));

      renderBundlesInRoot(document.getElementById('CartDrawer'));

    } finally {

      renderLock = false;

    }

  }

  function setBundleBusy(id, busy) {

    document.querySelectorAll('[data-ph-cart-bundle]').forEach(function (row) {

      if (row.getAttribute('data-ph-cart-bundle') !== id) return;

      row.classList.toggle('ph-cart-bundle-row--busy', busy);

      row.querySelectorAll('button, input').forEach(function (control) {

        control.disabled = busy;

      });

    });

  }

  function bundleKeys(id) {

    var row = null;

    document.querySelectorAll('[data-ph-cart-bundle]').forEach(function (candidate) {

      if (!row && candidate.getAttribute('data-ph-cart-bundle') === id) row = candidate;

    });

    if (!row) return null;

    var primaryKey = row.getAttribute('data-ph-bundle-primary-key');

    var companionKey = row.getAttribute('data-ph-bundle-companion-key');

    return primaryKey && companionKey ? [primaryKey, companionKey] : null;

  }

  function updateVisibleBundleQuantity(id, quantity) {

    document.querySelectorAll('[data-ph-bundle-quantity]').forEach(function (input) {

      if (input.getAttribute('data-ph-bundle-quantity') === id) input.value = quantity;

    });

  }

  function updateBundleQuantity(id, quantity) {

    quantity = Math.max(0, parseInt(quantity, 10) || 0);

    if (!id) return;

    var keys = bundleKeys(id);

    if (!keys) {

      window.alert('This bundle could not be matched to its cart lines. Please refresh the cart and try again.');

      return;

    }

    setBundleBusy(id, true);

    updateVisibleBundleQuantity(id, quantity);

    var updates = {};

    updates[keys[0]] = quantity;

    updates[keys[1]] = quantity;

    requestJson(ROOT + 'cart/update.js', {

      method: 'POST',

      headers: {

        'Content-Type': 'application/json',

        Accept: 'application/json',

      },

      body: JSON.stringify({

        updates: updates,

        sections: cartSectionsForPage(),

        sections_url: window.location.pathname,

      }),

    })

      .then(function (payload) {

        return applyCartState(payload, { openDrawer: false });

      })

      .catch(function (error) {

        console.error(error);

        window.alert(error.message || 'Unable to update this bundle.');

      })

      .finally(function () {

        setBundleBusy(id, false);

      });

  }

  function currentQuantityForControl(control) {

    var row = control.closest('[data-ph-cart-bundle]');

    if (!row) return 0;

    var input = row.querySelector('[data-ph-bundle-quantity]');

    return input ? Math.max(0, parseInt(input.value, 10) || 0) : 0;

  }

  function hookCartDrawer() {

    if (!window.customElements || typeof customElements.whenDefined !== 'function') return;

    customElements.whenDefined('cart-drawer').then(function () {

      var DrawerClass = customElements.get('cart-drawer');

      var proto = DrawerClass && DrawerClass.prototype;

      if (!proto || proto.__phBundleDomHooked) return;

      if (typeof proto.renderContents === 'function') {

        var originalRenderContents = proto.renderContents;

        proto.renderContents = function (parsedState, preventOpen) {

          var result = originalRenderContents.call(this, parsedState, preventOpen);

          if (result !== false) renderCartBundles();

          return result;

        };

      }

      if (typeof proto.open === 'function') {

        var originalOpen = proto.open;

        proto.open = function () {

          var result = originalOpen.apply(this, arguments);

          renderCartBundles();

          return result;

        };

      }

      proto.__phBundleDomHooked = true;

    });

  }

  document.addEventListener('click', function (event) {

    var bundleButton = event.target.closest && event.target.closest('[data-ph-bundle-button]');

    if (bundleButton) {

      event.preventDefault();

      addSelectedDeal(bundleButton.closest('[data-ph-bundle-deal]'), bundleButton);

      return;

    }

    var increase = event.target.closest && event.target.closest('[data-ph-bundle-increase]');

    if (increase) {

      event.preventDefault();

      var increaseId = increase.getAttribute('data-ph-bundle-increase');

      updateBundleQuantity(increaseId, currentQuantityForControl(increase) + 1);

      return;

    }

    var decrease = event.target.closest && event.target.closest('[data-ph-bundle-decrease]');

    if (decrease) {

      event.preventDefault();

      var decreaseId = decrease.getAttribute('data-ph-bundle-decrease');

      updateBundleQuantity(decreaseId, Math.max(0, currentQuantityForControl(decrease) - 1));

      return;

    }

    var remove = event.target.closest && event.target.closest('[data-ph-remove-bundle]');

    if (remove) {

      event.preventDefault();

      updateBundleQuantity(remove.getAttribute('data-ph-remove-bundle'), 0);

    }

  });

  document.addEventListener(

    'change',

    function (event) {

      var input = event.target.closest && event.target.closest('[data-ph-bundle-quantity]');

      if (!input) return;

      event.stopPropagation();

      if (event.stopImmediatePropagation) event.stopImmediatePropagation();

      updateBundleQuantity(input.getAttribute('data-ph-bundle-quantity'), input.value);

    },

    true

  );

  try {

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {

      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {

        renderCartBundles();

      });

    }

  } catch (error) {

    console.warn('Unable to subscribe to cart updates.', error);

  }

  function boot(root) {

    ensureBundleStyles();

    normaliseDisplayOnlyDiscounts(root || document);

    hookCartDrawer();

    renderCartBundles();

  }

  document.addEventListener('DOMContentLoaded', function () {

    boot(document);

  });

  document.addEventListener('shopify:section:load', function (event) {

    boot(event.target || document);

  });

  if (document.readyState !== 'loading') {

    boot(document);

  }

  window.renderProctersCartBundles = function () {

    renderCartBundles();

  };

  window.refreshProctersCartBundles = function () {

    renderCartBundles();

    return Promise.resolve();

  };


  
})();